import { type LucideProps } from 'lucide-react'

export default function Notion(props: LucideProps) {
  return (
    <svg viewBox='0 0 484 484' fill='none' {...props}>
      <path
        d='M130.833 179.492C131.161 134.734 148.911 91.8646 180.318 59.9746H180.26L59.0063 181.228H59.0641C58.6128 181.584 58.1872 181.97 57.7908 182.386C28.3021 211.836 10.4234 250.934 7.43594 292.503C4.4485 334.071 16.5527 375.324 41.5272 408.688L163.996 286.219L165.27 285.003C142.444 254.606 130.334 217.502 130.833 179.492V179.492Z'
        fill='currentColor'
      />
      <path
        d='M425.257 304.971C402.05 327.714 372.919 343.479 341.185 350.469C309.452 357.458 276.393 355.39 245.778 344.501C229.455 338.707 214.114 330.451 200.286 320.019L199.013 321.292L76.5439 443.704C109.922 468.616 151.151 480.682 192.694 477.695C234.237 474.709 273.316 456.87 302.788 427.44L304.003 426.225L425.257 304.971Z'
        fill='currentColor'
      />
      <path
        d='M477.232 181.228V16.0001C477.232 11.5818 473.65 8.00009 469.232 8.00009H304.004C281.253 7.97729 258.722 12.4497 237.705 21.1605C216.688 29.8713 197.599 42.6487 181.534 58.7589L180.319 59.9743C159.144 81.4707 143.995 108.157 136.39 137.357C150.157 133.792 164.305 131.907 178.525 131.743C216.536 131.295 253.63 143.422 284.036 166.238C311.363 186.617 332.045 214.63 343.476 246.746C355.126 279.571 356.658 315.137 347.875 348.842C377.08 341.25 403.769 326.098 425.257 304.913L426.473 303.755C442.59 287.684 455.371 268.586 464.082 247.558C472.793 226.531 477.262 203.989 477.232 181.228Z'
        fill='currentColor'
        fillOpacity='0.5'
      />
    </svg>
  )
}
